import { getImageWithAltFragment } from 'petdna-lib-uicomponents/hygraph';

export const SECTION_WHY_ANCESTRY_QUERY = `
    SectionWhyAncestry {
      id
      __typename
      backgroundColor {
        hex
      }
      name
      sectionType
      title {
        html
      }
      text {
        html
      }
      subText
      imageWithAlt {
        ${getImageWithAltFragment({})}
      }
      titleColor {
        hex
      } 
      textColor {
        hex
      }
    }`;
